/**
 * UM Settings feature policy names (operator-permission feature keys / JWT `PermissionPolicies`).
 * Maps to BE `InternalFeatureKeys.Settings` / `UM.Settings.Read` + `UM.Settings.Write` (TROC-243).
 *
 * Operator permissions API returns writable feature keys only — `Settings` means write access.
 * JWT may also include `UM.Settings.Read` for read-only viewers.
 */
export const SETTINGS_PERMISSION_POLICIES = {
  /** Settings feature write — Super Admin / Requestor (IT Manager); gates editing sensitivity. */
  WRITE: 'Settings',
  /** ASP.NET policy name — JWT fallback for Settings read access. */
  READ: 'UM.Settings.Read'
} as const;

export type SettingsPermissionPolicy = (typeof SETTINGS_PERMISSION_POLICIES)[keyof typeof SETTINGS_PERMISSION_POLICIES];
